export default "__VITE_ASSET__Bxi121Sz__"